import { InventoryProduct } from '../../types/inventories/model';
import { barcodePattern } from './barcodes';

export function filterProductsByNames(products: InventoryProduct[], search: string): InventoryProduct[] {
    const searchLowerCased = search.toLowerCase();
    return products.filter(({ name }) => name.toLowerCase().includes(searchLowerCased));
}

function filterProductsByBarcodes(products: InventoryProduct[], search: string): InventoryProduct[] {
    return products.filter(({ barcode }) => search === barcode)
}

export function getThisProduct(products: InventoryProduct[], search: string): InventoryProduct | false {
    if (barcodePattern.test(search)) {
        const productsFilteredByBarcode = filterProductsByBarcodes(products, search);
        if (productsFilteredByBarcode.length === 1) {
            return productsFilteredByBarcode[0];
        }
    }
    const productsFilteredByName = filterProductsByNames(products, search);
    if (productsFilteredByName.length === 1) {
        return productsFilteredByName[0];
    }
    return false;
}
